import React,{createContext,useContext} from 'react';

// Presentation only: never use these labels as persisted timestamps or sort keys.
export const TimeFormatContext=createContext('12h');
export const useTimeFormat=()=>useContext(TimeFormatContext);
export function preserveTimePreference(previous,next){
 if(previous&&next&&previous.email===next.email&&Number(previous.time_format_revision||0)>Number(next.time_format_revision||0))return {...next,time_format:previous.time_format,time_format_revision:previous.time_format_revision};
 return next;
}
export function formatDateTime(value,format='12h',options={}){
 const date=value instanceof Date?value:new Date(value);
 if(!Number.isFinite(date.getTime()))return 'Time unavailable';
 return date.toLocaleString(undefined,{...options,hourCycle:format==='24h'?'h23':'h12'});
}
export function formatWallTime(value,format='12h'){
 if(!value)return 'Capture time unavailable';
 // Keep the camera's recorded wall time, including ambiguous/nonexistent DST times.
 const wall=value.replace('T',' ');
 if(format==='24h')return wall;
 return wall.replace(/^(\d{4}-\d{2}-\d{2} )([01]\d|2[0-3])(:[0-5]\d(?::[0-5]\d(?:\.\d+)?)?)(.*)$/,(_all,date,hour,rest,suffix)=>date+(Number(hour)%12||12)+rest+(Number(hour)<12?' AM':' PM')+suffix);
}
export function DateTime({value,options,wall=false}){
 const format=useTimeFormat();
 return wall?formatWallTime(value,format):formatDateTime(value,format,options);
}
